// 图标搜索相关类型
export interface AppIcon {
  trackId: number;
  trackName: string;
  artworkUrl512: string;
  artworkUrl256?: string;
  artworkUrl128?: string;
  artistName: string;
  description?: string;
  country: string;
  primaryGenreName?: string;
  averageUserRating?: number;
  userRatingCount?: number;
  price?: number;
  formattedPrice?: string;
}

export interface SearchResponse {
  resultCount: number;
  results: AppIcon[];
}

export interface SearchParams {
  term: string;
  country: string;
  entity?: string;
  limit?: number;
  offset?: number;
}

// 区域配置
export const COUNTRIES = {
  cn: { code: 'cn', name: '中国', flag: '🇨🇳', currency: 'CNY' },
  us: { code: 'us', name: '美国', flag: '🇺🇸', currency: 'USD' },
  jp: { code: 'jp', name: '日本', flag: '🇯🇵', currency: 'JPY' },
  kr: { code: 'kr', name: '韩国', flag: '🇰🇷', currency: 'KRW' }
} as const;

export type CountryCode = keyof typeof COUNTRIES;

// 收藏的图标
export interface FavoriteIcon {
  id: string;
  trackId: number;
  trackName: string;
  artworkUrl: string;
  artistName: string;
  country: CountryCode;
  addedAt: number;
  tags: string[];
}

// API密钥配置
export interface ApiKey {
  id: string;
  name: string;
  key: string;
  provider: 'volcengine';
  usage: number;
  limit: number;
  createdAt: number;
  isActive: boolean;
}

// 用户设置
export interface UserSettings {
  theme: 'light' | 'dark' | 'auto';
  downloadFormat: 'png' | 'jpeg' | 'webp' | 'ico' | 'svg';
  downloadQuality: number;
  autoSaveFavorites: boolean;
  language: 'zh' | 'en' | 'ja' | 'ko';
  defaultCountry: CountryCode;
  apiKeys: ApiKey[];
}

// 搜索历史
export interface SearchHistory {
  queries: Array<{
    term: string;
    country: CountryCode;
    timestamp: number;
  }>;
  maxSize: number;
}

// AI编辑相关类型
export interface AIEditParams {
  image: string; // Base64 encoded image
  prompt: string;
  style?: 'cartoon' | 'realistic' | 'minimal' | 'vintage' | 'modern';
  strength?: number; // 0.1-1.0
  outputFormat?: 'png' | 'jpg' | 'webp';
  outputSize?: {
    width: number;
    height: number;
  };
}

export interface AIEditResponse {
  success: boolean;
  data?: {
    imageBase64: string;
    imageUrl?: string;
    taskId?: string;
  };
  error?: string;
}

// 下载选项
export interface DownloadOptions {
  format: 'png' | 'jpeg' | 'webp' | 'ico' | 'svg';
  quality: number;
  size?: {
    width: number;
    height: number;
  };
  filename?: string;
}

// 下载进度
export interface DownloadProgress {
  id: string;
  filename: string;
  progress: number; // 0-100
  status: 'pending' | 'downloading' | 'completed' | 'error';
  error?: string;
  url?: string;
}

// 应用状态
export interface AppState {
  isLoading: boolean;
  error: string | null;
  currentCountry: CountryCode;
  searchQuery: string;
  searchResults: AppIcon[];
  favorites: FavoriteIcon[];
  apiKeys: ApiKey[];
  settings: UserSettings;
  downloadProgress: DownloadProgress[];
}

// API响应类型
export interface ApiResponse<T> {
  success: boolean;
  data?: T;
  error?: string;
  message?: string;
}
